module.exports = __webpack_public_path__ + "static/media/PRISM flyer.38bdd668.sketch";